import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useDefectReportPictureV1ControllerGetByDefect } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetDefectReportPicturesData = (
  defectId: string | undefined,
) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityControl);

  const { data, error, isLoading } =
    useDefectReportPictureV1ControllerGetByDefect({
      queryParams: {
        defectId: defectId ?? '',
      },
      headers: restHeaders,
    });

  return {
    data,
    isLoading,
    error,
  };
};
